import {
  FETCHING_ACCOUNT_SUMMARY_REQUEST,
  FETCHING_ACCOUNT_SUMMARY_SUCCEDDED,
  FETCHING_ACCOUNT_SUMMARY_FAILED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST,
  FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT,
  FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_POPULAR_ASSETS,
  FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED,
  FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED,
  FETCHING_DISCOVERY_TOP_USERS,
  FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED,
  FETCHING_DISCOVERY_TOP_USERS_FAILED,
  FETCHING_DISCOVERY_TOP_USER_GROUPS,
  FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED,
  FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED,
  FETCHING_DISCOVERY_SEARCH_QUERIES,
  FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED,
  FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED,
  FETCHING_DISCOVERY_SEARCH_TAGS,
  FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED,
  FETCHING_DISCOVERY_SEARCH_TAGS_FAILED,
  FETCHING_DISCOVERY_USER_ACTIVITIES,
  FETCHING_DISCOVERY_USER_ACTIVITIES_SUCCEDDED,
  FETCHING_DISCOVERY_USER_ACTIVITIES_FAILED,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED,
  FETCHING_ENGAGEMENT_TOP_USERS,
  FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_USERS_FAILED,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED,
  INTIALIZING_DOWNLOAD_REPORT_REQUEST,
  INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED,
  INTIALIZING_DOWNLOAD_REPORT_FAILED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED,
  INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS,
  FETCHING_PERFORMANCE_SUMMARY_REQUEST,
  FETCHING_PERFORMANCE_SUMMARY_SUCCEEDED,
  FETCHING_PERFORMANCE_SUMMARY_FAILED,
  FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED,
  FETCHING_PERFORMANCE_INTERACTIONS_FAILED,
  FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_LEADS_SUCCEEDED,
  FETCHING_PERFORMANCE_LEADS_FAILED,
  FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_DEALS_SUCCEEDED,
  FETCHING_PERFORMANCE_DEALS_FAILED,
  FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT,
  FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED,
  FETCHING_PERFORMANCE_DEAL_VALUE_FAILED,
  FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED,
  FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED,
  FETCHING_CLOSED_DEALS_DETAIL_REPORT,
  FETCHING_CLOSED_DEALS_DETAIL_REPORT_SUCCEEDED,
  FETCHING_CLOSED_DEALS_DETAIL_REPORT_FAILED,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED,
  FETCHING_LEADS_DETAIL_REPORT,
  FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED,
  FETCHING_LEADS_DETAIL_REPORT_FAILED,
  UPDATE_FILTERS_IN_REPORTS,
  SAVE_FILTER_REQUEST,
  SAVING_FILTER_REQUEST_SUCCEEDED,
  SAVING_FILTER_REQUEST_FAILED,
  FETCH_ALL_FILTERS_REQUEST,
  FETCHING_ALL_FILTERS_SUCCEEDED,
  FETCHING_ALL_FILTERS_FAILED,
  SELECT_FILTER_REQUEST,
  UPDATE_FILTER_REQUEST,
  UPDATING_FILTER_REQUEST_SUCCEEDED,
  UPDATING_FILTER_REQUEST_FAILED,
  FETCH_FILTER_REQUEST,
  FETCHING_FILTER_REQUEST_SUCCEEDED,
  FETCHING_FILTER_REQUEST_FAILED,
  FETCHING_DISCOVERY_TOP_SHARERS,
  FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED,
  FETCHING_DISCOVERY_TOP_SHARERS_FAILED,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED,
  FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST,
  FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED,
  FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED,
  RESET_REPORT_DOWNLOAD,
} from "./actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url-ts";


const apiUrl = `${process.env.REACT_APP_API_URL}`;

const REPORT_BASE_URL = `${apiUrl}/api/2.0/reports`;
const REPORT_FILTER_BASE_URL = `${apiUrl}/api/2.0/reports/filter`;

/**
 * Fetching account summary
 */

export function fetchSummaryDetails(filter) {
  return function (dispatch) {
    dispatch(fetchingSummaryDetails());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `account/summary`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingSummaryDetailsSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingSummaryDetailsFailed(error));
      });
  };
}

function fetchingSummaryDetails() {
  return {
    type: FETCHING_ACCOUNT_SUMMARY_REQUEST,
    payload: {},
  };
}

function fetchingSummaryDetailsSuccedded(json) {
  return {
    type: FETCHING_ACCOUNT_SUMMARY_SUCCEDDED,
    payload: json,
  };
}

function fetchingSummaryDetailsFailed(error) {
  return {
    type: FETCHING_ACCOUNT_SUMMARY_FAILED,
    payload: error,
  };
}

/**
 * Fetching Discovery content Matrix
 */
export function fetchDiscoveryContentMatrix(filter) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryContentMatrix());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/content-matrix`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryContentMatrixSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryContentMatrixFailed(error));
      });
  };
}

function fetchingDiscoveryContentMatrix() {
  return {
    type: FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST,
    payload: {},
  };
}

function fetchingDiscoveryContentMatrixSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryContentMatrixFailed(error) {
  return {
    type: FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED,
    payload: error,
  };
}

/**
 * Fetching discovery content matrix assets
 */
export function fetchDiscoveryContentMatrxAssets(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryContentMatrxAssets());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/content-matrix/assets`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      data: filter,
      params: params,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryContentMatrxAssetsSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryContentMatrxAssetsFailed(error));
      });
  };
}

function fetchingDiscoveryContentMatrxAssets() {
  return {
    type: FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST,
    payload: {},
  };
}

function fetchingDiscoveryContentMatrxAssetsSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryContentMatrxAssetsFailed(error) {
  return {
    type: FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED,
    payload: error,
  };
}

export function invalidateContentMatrixAssets() {
  return {
    type: INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS,
    payload: {},
  };
}

/**
 * Fetching Discovery Asset views graph
 */
export function fetchDiscoveryAssetViewsGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryAssetViewsGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/asset_views/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryAssetViewsGraphReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryAssetViewsGraphReportFailed(error));
      });
  };
}

function fetchingDiscoveryAssetViewsGraphReport() {
  return {
    type: FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingDiscoveryAssetViewsGraphReportSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryAssetViewsGraphReportFailed(error) {
  return {
    type: FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching Discovery Asset count graph
 */
export function fetchDiscoveryAssetsGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryAssetsGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/assets/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryAssetsGraphReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryAssetsGraphReportFailed(error));
      });
  };
}

function fetchingDiscoveryAssetsGraphReport() {
  return {
    type: FETCHING_DISCOVERY_ASSET_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingDiscoveryAssetsGraphReportSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryAssetsGraphReportFailed(error) {
  return {
    type: FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching Discovery team members graph
 */

export function fetchDiscoveryTeamMembersGraphReport(startdate, enddate) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryTeamMembersGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/team_members/graph`,
    });

    let params = {
      startDate: startdate,
      endDate: enddate,
    };

    return axios({
      method: "GET",
      url: url,
      params: params,
    })
      .then((response) =>
        dispatch(
          fetchingDiscoveryTeamMembersGraphReportSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryTeamMembersGraphReportFailed(error));
      });
  };
}

function fetchingDiscoveryTeamMembersGraphReport() {
  return {
    type: FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingDiscoveryTeamMembersGraphReportSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryTeamMembersGraphReportFailed(error) {
  return {
    type: FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching Discovery Share count graph
 */

export function fetchDiscoveryShareGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryShareGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/share/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryShareGraphReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryShareGraphReportFailed(error));
      });
  };
}

function fetchingDiscoveryShareGraphReport() {
  return {
    type: FETCHING_DISCOVERY_SHARE_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingDiscoveryShareGraphReportSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryShareGraphReportFailed(error) {
  return {
    type: FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching popular Assets
 */

export function fetchDiscoveryPopularAssets(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryPopularAssets());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/popular-assets`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryPopularAssetsSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryPopularAssetsFailed(error));
      });
  };
}

function fetchingDiscoveryPopularAssets() {
  return {
    type: FETCHING_DISCOVERY_POPULAR_ASSETS,
    payload: {},
  };
}

function fetchingDiscoveryPopularAssetsSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryPopularAssetsFailed(error) {
  return {
    type: FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED,
    payload: error,
  };
}

/**
 * Fetching top Users
 */
export function fetchDiscoveryTopUsers(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryTopUsers());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/top-users`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryTopUsersSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryTopUsersFailed(error));
      });
  };
}

function fetchingDiscoveryTopUsers() {
  return {
    type: FETCHING_DISCOVERY_TOP_USERS,
    payload: {},
  };
}

function fetchingDiscoveryTopUsersSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryTopUsersFailed(error) {
  return {
    type: FETCHING_DISCOVERY_TOP_USERS_FAILED,
    payload: error,
  };
}

/**
 * Fetching top Users
 */
export function fetchDiscoveryTopSharers(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryTopSharers());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/top-sharers`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchDiscoveryTopSharersSucceeded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchDiscoveryTopSharersFailed(error));
      });
  };
}

function fetchingDiscoveryTopSharers() {
  return {
    type: FETCHING_DISCOVERY_TOP_SHARERS,
    payload: {},
  };
}

function fetchDiscoveryTopSharersSucceeded(json) {
  return {
    type: FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED,
    payload: json,
  };
}

function fetchDiscoveryTopSharersFailed(error) {
  return {
    type: FETCHING_DISCOVERY_TOP_SHARERS_FAILED,
    payload: error,
  };
}

/**
 * Fetching top User groups
 */
export function fetchDiscoveryTopUserGroups(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryTopUserGroups());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/top-user-groups`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryTopUserGroupsSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryTopUserGroupsFailed(error));
      });
  };
}

function fetchingDiscoveryTopUserGroups() {
  return {
    type: FETCHING_DISCOVERY_TOP_USER_GROUPS,
    payload: {},
  };
}

function fetchingDiscoveryTopUserGroupsSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryTopUserGroupsFailed(error) {
  return {
    type: FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED,
    payload: error,
  };
}

/**
 * Fetching collections created
 */
export function fetchDiscoveryCollections(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryCollections());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/collections`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryCollectionsSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryCollectionsFailed(error));
      });
  };
}

function fetchingDiscoveryCollections() {
  return {
    type: FETCHING_DISCOVERY_COLLECTIONS_REPORT,
    payload: {},
  };
}

function fetchingDiscoveryCollectionsSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryCollectionsFailed(error) {
  return {
    type: FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching collections shared
 */
export function fetchDiscoveryCollectionsShared(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryCollectionsShared());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/collections_shared`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryCollectionsSharedSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryCollectionsSharedFailed(error));
      });
  };
}

function fetchingDiscoveryCollectionsShared() {
  return {
    type: FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT,
    payload: {},
  };
}

function fetchingDiscoveryCollectionsSharedSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryCollectionsSharedFailed(error) {
  return {
    type: FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching Assets shared
 */
export function fetchDiscoveryAssetsShared(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryAssetsShared());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/assets_shared`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryAssetsSharedSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryAssetsSharedFailed(error));
      });
  };
}

function fetchingDiscoveryAssetsShared() {
  return {
    type: FETCHING_DISCOVERY_ASSETS_SHARED_REPORT,
    payload: {},
  };
}

function fetchingDiscoveryAssetsSharedSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryAssetsSharedFailed(error) {
  return {
    type: FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching search queries
 */
export function fetchDiscoverySearchQueries(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDiscoverySearchQueries());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/search-query`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoverySearchQueriesSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoverySearchQueriesFailed(error));
      });
  };
}

function fetchingDiscoverySearchQueries() {
  return {
    type: FETCHING_DISCOVERY_SEARCH_QUERIES,
    payload: {},
  };
}

function fetchingDiscoverySearchQueriesSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoverySearchQueriesFailed(error) {
  return {
    type: FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED,
    payload: error,
  };
}

/**
 * Fetching search tags
 */

export function fetchDiscoverySearchTags(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDiscoverySearchTags());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/tags`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDiscoverySearchTagsSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoverySearchTagsFailed(error));
      });
  };
}

function fetchingDiscoverySearchTags() {
  return {
    type: FETCHING_DISCOVERY_SEARCH_TAGS,
    payload: {},
  };
}

function fetchingDiscoverySearchTagsSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoverySearchTagsFailed(error) {
  return {
    type: FETCHING_DISCOVERY_SEARCH_TAGS_FAILED,
    payload: error,
  };
}

/**
 * Fetching Discovery Collection Activity graph
 */

export function fetchDiscoveryCollectionActivityGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryCollectionActivityGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/collection-activity/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(
          fetchingDiscoveryCollectionActivityGraphReportSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(
          fetchingDiscoveryCollectionActivityGraphReportFailed(error)
        );
      });
  };
}

function fetchingDiscoveryCollectionActivityGraphReport() {
  return {
    type: FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingDiscoveryCollectionActivityGraphReportSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryCollectionActivityGraphReportFailed(error) {
  return {
    type: FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching user activities
 */

export function fetchDiscoveryUserActivity(
  page,
  startDate,
  endDate,
  userGroupId
) {
  return function (dispatch) {
    dispatch(fetchingDiscoveryUserActivities());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `discovery/user-activity`,
    });

    let params = {
      page: page,
      startDate: startDate,
      endDate: endDate,
      userGroupId: userGroupId,
    };

    return axios({
      method: "GET",
      url: url,
      params: params,
    })
      .then((response) =>
        dispatch(fetchingDiscoveryUserActivitiesSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDiscoveryUserActivitiesFailed(error));
      });
  };
}

function fetchingDiscoveryUserActivities() {
  return {
    type: FETCHING_DISCOVERY_USER_ACTIVITIES,
    payload: {},
  };
}

function fetchingDiscoveryUserActivitiesSuccedded(json) {
  return {
    type: FETCHING_DISCOVERY_USER_ACTIVITIES_SUCCEDDED,
    payload: json,
  };
}

function fetchingDiscoveryUserActivitiesFailed(error) {
  return {
    type: FETCHING_DISCOVERY_USER_ACTIVITIES_FAILED,
    payload: error,
  };
}

/**
 * Fetching Engagement Asset views graph
 */
export function fetchEngagementAssetViewsGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingEngagementAssetViewsGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/asset_views/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(
          fetchingEngagementAssetViewsGraphReportSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingEngagementAssetViewsGraphReportFailed(error));
      });
  };
}

function fetchingEngagementAssetViewsGraphReport() {
  return {
    type: FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingEngagementAssetViewsGraphReportSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementAssetViewsGraphReportFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching Engagement Share count graph
 */
export function fetchEngagementShareGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingEngagementShareGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/share/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingEngagementShareGraphReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingEngagementShareGraphReportFailed(error));
      });
  };
}

function fetchingEngagementShareGraphReport() {
  return {
    type: FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingEngagementShareGraphReportSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementShareGraphReportFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching Engagement unique viewers count graph
 */
export function fetchEngagementUniqueViewersGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingEngagementUniqueViewersGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/unique-viewers/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(
          fetchingEngagementUniqueViewersGraphReportSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(
          fetchingEngagementUniqueViewersGraphReportFailed(error)
        );
      });
  };
}

function fetchingEngagementUniqueViewersGraphReport() {
  return {
    type: FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingEngagementUniqueViewersGraphReportSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementUniqueViewersGraphReportFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching Engagement Attention Time count graph
 */

export function fetchEngagementAttentionTimeGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingEngagementAttentionTimeGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/attention-time/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(
          fetchingEngagementAttentionTimeGraphReportSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(
          fetchingEngagementAttentionTimeGraphReportFailed(error)
        );
      });
  };
}

function fetchingEngagementAttentionTimeGraphReport() {
  return {
    type: FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingEngagementAttentionTimeGraphReportSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementAttentionTimeGraphReportFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Fetching engagement popular Assets
 */
export function fetchEngagementPopularAssets(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingEngagementPopularAssets());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/popular-assets`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingEngagementPopularAssetsSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingEngagementPopularAssetsFailed(error));
      });
  };
}

function fetchingEngagementPopularAssets() {
  return {
    type: FETCHING_ENGAGEMENT_POPULAR_ASSETS,
    payload: {},
  };
}

function fetchingEngagementPopularAssetsSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementPopularAssetsFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED,
    payload: error,
  };
}

/**
 * Fetching engagement top Users
 */
export function fetchEngagementTopUsers(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingEngagementTopUsers());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/top-users`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingEngagementTopUsersSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingEngagementTopUsersFailed(error));
      });
  };
}

function fetchingEngagementTopUsers() {
  return {
    type: FETCHING_ENGAGEMENT_TOP_USERS,
    payload: {},
  };
}

function fetchingEngagementTopUsersSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementTopUsersFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_TOP_USERS_FAILED,
    payload: error,
  };
}

/**
 * Fetching engagement top user accounts
 */
export function fetchEngagementTopAccounts(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingEngagementTopAccounts());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/top-accounts`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingEngagementTopAccountsSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingEngagementTopAccountsFailed(error));
      });
  };
}

function fetchingEngagementTopAccounts() {
  return {
    type: FETCHING_ENGAGEMENT_TOP_ACCOUNTS,
    payload: {},
  };
}

function fetchingEngagementTopAccountsSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementTopAccountsFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED,
    payload: error,
  };
}

/**
 * Fetching engagement top Camapigns
 */
export function fetchEngagementCampaigns(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingEngagementCampaigns());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/campaigns`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingEngagementCampaignsSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingEngagementCampaignsFailed(error));
      });
  };
}

function fetchingEngagementCampaigns() {
  return {
    type: FETCHING_ENGAGEMENT_TOP_CAMPAIGNS,
    payload: {},
  };
}

function fetchingEngagementCampaignsSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementCampaignsFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED,
    payload: error,
  };
}

/**
 * Fetching engagement top Camapign sources
 */
export function fetchEngagementCampaignSources(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingEngagementCampaignSources());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/campaign-sources`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingEngagementCampaignSourcesSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingEngagementCampaignSourcesFailed(error));
      });
  };
}

function fetchingEngagementCampaignSources() {
  return {
    type: FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES,
    payload: {},
  };
}

function fetchingEngagementCampaignSourcesSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementCampaignSourcesFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED,
    payload: error,
  };
}

/**
 * Fetching Conversation Activity
 */
export function fetchEngagementShareReport(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingEngagementShareReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/shares`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingEngagementShareReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingEngagementShareReportFailed(error));
      });
  };
}

function fetchingEngagementShareReport() {
  return {
    type: FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES,
    payload: {},
  };
}

function fetchingEngagementShareReportSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementShareReportFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED,
    payload: error,
  };
}

/**
 * Fetching Collection Activity for engagement
 */
export function fetchEngagementCollectionActivityReport(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingEngagementCollectionActivities());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `engagement/collections`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingEngagementCollectionActivitiesSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingEngagementCollectionActivitiesFailed(error));
      });
  };
}

function fetchingEngagementCollectionActivities() {
  return {
    type: FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES,
    payload: {},
  };
}

function fetchingEngagementCollectionActivitiesSuccedded(json) {
  return {
    type: FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED,
    payload: json,
  };
}

function fetchingEngagementCollectionActivitiesFailed(error) {
  return {
    type: FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED,
    payload: error,
  };
}

/**
 * Intialting download request for report
 */
export function intializeDownloadReport(id, request, page, limit) {
  return function (dispatch) {
    dispatch(initializingDownloadReport(page));

    let url = buildUrl(REPORT_BASE_URL, {
      path: `/download/${id}/data`,
    });

    let params = {
      page,
      limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: request,
    })
      .then((response) =>
        dispatch(initializingDownloadReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(initializingDownloadReportFailed(error));
      });
  };
}

function initializingDownloadReport(page) {
  return {
    type: INTIALIZING_DOWNLOAD_REPORT_REQUEST,
    payload: { page },
  };
}

function initializingDownloadReportSuccedded(json) {
  return {
    type: INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED,
    payload: json,
  };
}

function initializingDownloadReportFailed(error) {
  return {
    type: INTIALIZING_DOWNLOAD_REPORT_FAILED,
    payload: error,
  };
}

/**
 * Performance graph report
 */

export function fetchPerformanceInteractionsGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingPerformanceInteractionsGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/interactions/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(
          fetchingPerformanceInteractionsGraphReportSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(
          fetchingPerformanceInteractionsGraphReportFailed(error)
        );
      });
  };
}

function fetchingPerformanceInteractionsGraphReport() {
  return {
    type: FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingPerformanceInteractionsGraphReportSuccedded(json) {
  return {
    type: FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED,
    payload: json,
  };
}

function fetchingPerformanceInteractionsGraphReportFailed(error) {
  return {
    type: FETCHING_PERFORMANCE_INTERACTIONS_FAILED,
    payload: error,
  };
}

export function fetchPerformanceSummaryDetails(filter) {
  return function (dispatch) {
    dispatch(fetchingPerformamceSummaryDetails());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/summary`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingPerformanceSummaryDetailsSucceeded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingPerformanceSummaryDetailsFailed(error));
      });
  };
}

function fetchingPerformamceSummaryDetails() {
  return {
    type: FETCHING_PERFORMANCE_SUMMARY_REQUEST,
    payload: {},
  };
}

function fetchingPerformanceSummaryDetailsSucceeded(json) {
  return {
    type: FETCHING_PERFORMANCE_SUMMARY_SUCCEEDED,
    payload: json,
  };
}

function fetchingPerformanceSummaryDetailsFailed(error) {
  return {
    type: FETCHING_PERFORMANCE_SUMMARY_FAILED,
    payload: error,
  };
}

/**
 * Performance graph report
 */

export function fetchPerformanceLeadsGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingPerformanceLeadsGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/leads/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingPerformanceLeadsGraphReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingPerformanceLeadsGraphReportFailed(error));
      });
  };
}

function fetchingPerformanceLeadsGraphReport() {
  return {
    type: FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingPerformanceLeadsGraphReportSuccedded(json) {
  return {
    type: FETCHING_PERFORMANCE_LEADS_SUCCEEDED,
    payload: json,
  };
}

function fetchingPerformanceLeadsGraphReportFailed(error) {
  return {
    type: FETCHING_PERFORMANCE_LEADS_FAILED,
    payload: error,
  };
}

export function fetchPerformanceDealsGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingPerformanceDealsGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/deals/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingPerformanceDealsGraphReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingPerformanceDealsGraphReportFailed(error));
      });
  };
}

function fetchingPerformanceDealsGraphReport() {
  return {
    type: FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingPerformanceDealsGraphReportSuccedded(json) {
  return {
    type: FETCHING_PERFORMANCE_DEALS_SUCCEEDED,
    payload: json,
  };
}

function fetchingPerformanceDealsGraphReportFailed(error) {
  return {
    type: FETCHING_PERFORMANCE_DEALS_FAILED,
    payload: error,
  };
}

export function fetchPerformanceDealValueGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingPerformanceDealValueGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/dealValue/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(
          fetchingPerformanceDealValueGraphReportSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingPerformanceDealValueGraphReportFailed(error));
      });
  };
}

function fetchingPerformanceDealValueGraphReport() {
  return {
    type: FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingPerformanceDealValueGraphReportSuccedded(json) {
  return {
    type: FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED,
    payload: json,
  };
}

function fetchingPerformanceDealValueGraphReportFailed(error) {
  return {
    type: FETCHING_PERFORMANCE_DEAL_VALUE_FAILED,
    payload: error,
  };
}

export function fetchPerformanceClosedDealsGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingPerformanceClosedDealsGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/closedDeals/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(
          fetchingPerformanceClosedDealsGraphReportSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingPerformanceClosedDealsGraphReportFailed(error));
      });
  };
}

function fetchingPerformanceClosedDealsGraphReport() {
  return {
    type: FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingPerformanceClosedDealsGraphReportSuccedded(json) {
  return {
    type: FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED,
    payload: json,
  };
}

function fetchingPerformanceClosedDealsGraphReportFailed(error) {
  return {
    type: FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED,
    payload: error,
  };
}

export function fetchPerformanceClosedDealValueGraphReport(filter) {
  return function (dispatch) {
    dispatch(fetchingPerformanceClosedDealValueGraphReport());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/closedDealValue/graph`,
    });

    return axios({
      method: "POST",
      url: url,
      data: filter,
    })
      .then((response) =>
        dispatch(
          fetchingPerformanceClosedDealValueGraphReportSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(
          fetchingPerformanceClosedDealValueGraphReportFailed(error)
        );
      });
  };
}

function fetchingPerformanceClosedDealValueGraphReport() {
  return {
    type: FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT,
    payload: {},
  };
}

function fetchingPerformanceClosedDealValueGraphReportSuccedded(json) {
  return {
    type: FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED,
    payload: json,
  };
}

function fetchingPerformanceClosedDealValueGraphReportFailed(error) {
  return {
    type: FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED,
    payload: error,
  };
}

/**
 * Fetching top contents generating leads
 */
export function fetchPerformanceTopContentGeneratingLeads(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingPerformanceTopContentGeneratingLeads());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/top-leads-content`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(
          fetchingPerformanceTopContentGeneratingLeadsSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(
          fetchingPerformanceTopContentGeneratingLeadsFailed(error)
        );
      });
  };
}

function fetchingPerformanceTopContentGeneratingLeads() {
  return {
    type: FETCHING_PERFORMANCE_TOP_LEADS_CONTENT,
    payload: {},
  };
}

function fetchingPerformanceTopContentGeneratingLeadsSuccedded(json) {
  return {
    type: FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED,
    payload: json,
  };
}

function fetchingPerformanceTopContentGeneratingLeadsFailed(error) {
  return {
    type: FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED,
    payload: error,
  };
}

/**
 * Fetching top content closed deals
 */

export function fetchPerformanceTopContentClosedDeals(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingPerformanceTopContentClosedDeals());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/top-content-closed-deals`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(
          fetchingPerformanceTopContentClosedDealsSuccedded(response.data)
        )
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingPerformanceTopContentClosedDealsFailed(error));
      });
  };
}

function fetchingPerformanceTopContentClosedDeals() {
  return {
    type: FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS,
    payload: {},
  };
}

function fetchingPerformanceTopContentClosedDealsSuccedded(json) {
  return {
    type: FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED,
    payload: json,
  };
}

function fetchingPerformanceTopContentClosedDealsFailed(error) {
  return {
    type: FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED,
    payload: error,
  };
}

export function fetchClosedDealsDetailReport(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingClosedDealsDetail());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/closedDeals/detail`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingClosedDealsDetailReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingClosedDealsDetailReportFailed(error));
      });
  };
}

function fetchingClosedDealsDetail() {
  return {
    type: FETCHING_CLOSED_DEALS_DETAIL_REPORT,
    payload: {},
  };
}

function fetchingClosedDealsDetailReportSuccedded(json) {
  return {
    type: FETCHING_CLOSED_DEALS_DETAIL_REPORT_SUCCEEDED,
    payload: json,
  };
}

function fetchingClosedDealsDetailReportFailed(error) {
  return {
    type: FETCHING_CLOSED_DEALS_DETAIL_REPORT_FAILED,
    payload: error,
  };
}

export function fetchDealsDetailReport(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingDealsDetail());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/deals/detail`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingDealsDetailReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingDealsDetailReportFailed(error));
      });
  };
}

function fetchingDealsDetail() {
  return {
    type: FETCHING_DEALS_REQUEST_DETAIL_REPORT,
    payload: {},
  };
}

function fetchingDealsDetailReportSuccedded(json) {
  return {
    type: FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED,
    payload: json,
  };
}

function fetchingDealsDetailReportFailed(error) {
  return {
    type: FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED,
    payload: error,
  };
}

export function fetchLeadsDetailReport(filter, page, limit) {
  return function (dispatch) {
    dispatch(fetchingLeadsDetail());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `performance/leads/detail`,
    });

    let params = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter,
    })
      .then((response) =>
        dispatch(fetchingLeadsDetailReportSuccedded(response.data))
      )
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingLeadsDetailReportFailed(error));
      });
  };
}

function fetchingLeadsDetail() {
  return {
    type: FETCHING_LEADS_DETAIL_REPORT,
    payload: {},
  };
}

function fetchingLeadsDetailReportSuccedded(json) {
  return {
    type: FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED,
    payload: json,
  };
}

function fetchingLeadsDetailReportFailed(error) {
  return {
    type: FETCHING_LEADS_DETAIL_REPORT_FAILED,
    payload: error,
  };
}

// Update Filters in Reports

export function updateFiltersInReports(filters) {
  return {
    type: UPDATE_FILTERS_IN_REPORTS,
    payload: {
      filters: filters,
    },
  };
}

// Save Report Filters

export function saveFilter(request) {
  return function (dispatch) {
    dispatch(saveFilterRequest());

    return axios({
      method: "POST",
      url: REPORT_FILTER_BASE_URL,
      data: request,
    })
      .then((response) => dispatch(savingFilterRequestSucceeded(response.data)))
      .catch((error) => {
        console.log(error);
        return dispatch(savingFilterRequestFailed(error));
      });
  };
}

function saveFilterRequest() {
  return {
    type: SAVE_FILTER_REQUEST,
    payload: {},
  };
}

function savingFilterRequestSucceeded(json) {
  return {
    type: SAVING_FILTER_REQUEST_SUCCEEDED,
    payload: json,
  };
}

function savingFilterRequestFailed(error) {
  return {
    type: SAVING_FILTER_REQUEST_FAILED,
    payload: error,
  };
}

// Fetch All Filters

export function fetchFilters(page, limit) {
  return function (dispatch) {
    dispatch(fetchAllFilters());

    let param = {
      page: page,
      limit: limit,
    };

    return axios({
      method: "GET",
      url: REPORT_FILTER_BASE_URL,
      params: param,
    })
      .then((response) => dispatch(fetchingAllFiltersSucceeded(response.data)))
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingAllFiltersFailed(error));
      });
  };
}

function fetchAllFilters() {
  return {
    type: FETCH_ALL_FILTERS_REQUEST,
    payload: {},
  };
}

function fetchingAllFiltersSucceeded(json) {
  return {
    type: FETCHING_ALL_FILTERS_SUCCEEDED,
    payload: json,
  };
}

function fetchingAllFiltersFailed(error) {
  return {
    type: FETCHING_ALL_FILTERS_FAILED,
    payload: error,
  };
}

// Select Filter
export function selectFilter(filter) {
  return {
    type: SELECT_FILTER_REQUEST,
    payload: {
      filter: filter,
    },
  };
}

/*
 * Update Filter
 */
export function updateFilter(id, request) {
  return function (dispatch) {
    dispatch(updatingFilter(id));

    let url = buildUrl(REPORT_FILTER_BASE_URL, {
      path: id,
    });

    return axios({
      method: "PUT",
      url: url,
      data: request,
    })
      .then((response) => dispatch(updatingFilterSucceeded(response.data)))
      .catch((error) => dispatch(updatingFilterFailed(error)));
  };
}

function updatingFilter(id) {
  return {
    type: UPDATE_FILTER_REQUEST,
    payload: id,
  };
}

function updatingFilterSucceeded(json) {
  return {
    type: UPDATING_FILTER_REQUEST_SUCCEEDED,
    payload: json,
  };
}

function updatingFilterFailed(error) {
  return {
    type: UPDATING_FILTER_REQUEST_FAILED,
    payload: error,
  };
}

/*
 * Fetch a Filter
 */
export function fetchFilter(id) {
  return function (dispatch) {
    dispatch(fetchingFilter(id));

    let url = buildUrl(REPORT_FILTER_BASE_URL, {
      path: id,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) => dispatch(fetchingFilterSucceeded(response.data)))
      .catch((error) => dispatch(fetchingFilterFailed(error)));
  };
}

function fetchingFilter(id) {
  return {
    type: FETCH_FILTER_REQUEST,
    payload: id,
  };
}

function fetchingFilterSucceeded(json) {
  return {
    type: FETCHING_FILTER_REQUEST_SUCCEEDED,
    payload: json,
  };
}

function fetchingFilterFailed(error) {
  return {
    type: FETCHING_FILTER_REQUEST_FAILED,
    payload: error,
  };
}

export function fetchReportSummaryNudges(nudgesType) {
  return function (dispatch) {
    dispatch(fetchingSummaryNudges());

    let url = buildUrl(REPORT_BASE_URL, {
      path: `account/${nudgesType}/summary`,
    });

    return axios({
      method: "GET",
      url: url
    })
      .then((response) =>
        dispatch(fetchingSummaryNudgesSuccedded(response.data, nudgesType))
      )
      .catch((error) => {
        return dispatch(fetchingSummaryNudgesFailed(error));
      });
  };
}

function fetchingSummaryNudges(){
  return {
    type : FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST,
    payload: {}
  }
}

function fetchingSummaryNudgesSuccedded(json, type){
  return {
    type : FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED,
    payload: json,
    key: type
  }
}

function fetchingSummaryNudgesFailed(error){
  return {
    type : FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED,
    payload: {error}
  }
}


export function resetReportDownload() {
  return {
    type: RESET_REPORT_DOWNLOAD,
    payload: {},
  }
}